"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Rels_1 = require("../models/Rels");
const WmsRestClient_1 = __importDefault(require("../utils/WmsRestClient"));
//import Env from "@env";
class TransactionsAccessor {
    constructor(wmsRestClient) {
        if (!wmsRestClient) {
            const billboardHost = process.env.WMS_BILLBOARD_HOST;
            if (!billboardHost) {
                throw new Error('WMS_BILLBOARD_HOST must be present in the process environment');
            }
            // Not required in the environment, will be used if provided
            const s3BillboardUrl = process.env.WMS_S3_BILLBOARD_URL ?? '';
            const wmsAuthBasic = process.env.WMS_AUTH_BASIC;
            if (!wmsAuthBasic) {
                throw new Error('WMS_AUTH_BASIC must be present in the process environment');
            }
            wmsRestClient = new WmsRestClient_1.default(billboardHost, s3BillboardUrl);
            wmsRestClient.wmsHost = billboardHost;
            wmsRestClient.wmsAuthBasic = wmsAuthBasic;
        }
        this._wmsRestClient = wmsRestClient;
    }
    _wmsRestClient;
    async getOrder(tplGuid, orderId, detail, itemdetail) {
        const tempOrderURI = await this._wmsRestClient.billboardUri(Rels_1.Rels.OrderSvc.Order);
        const orderURI = this._wmsRestClient.substituteValues(tempOrderURI.href, {
            id: `${orderId}`,
            ...(detail ? { detail } : {}),
            ...(itemdetail ? { itemdetail } : {}),
        });
        const order = await this._wmsRestClient.get(orderURI, tplGuid, 'application/hal+json');
        return order;
    }
}
exports.default = TransactionsAccessor;
